"use client";

const _excluded = ["size"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
import React from "react";
import BaseIcon from "../../utils/BaseIcon";
const PriceGraphicIcon = props => {
  const {
      size = 48
    } = props,
    otherProps = _objectWithoutProperties(props, _excluded);
  const iconFill = "currentColor";
  return /*#__PURE__*/React.createElement(BaseIcon, _extends({
    size: size
  }, otherProps, {
    "data-mesh-component": "PRICE-GRAPHIC-ICON"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: iconFill,
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.372 0 0 5.371 0 12s5.372 12 12 12 12-5.372 12-12S18.629 0 12 0Zm0 1c6.076 0 11 4.924 11 11s-4.924 11-11 11S1 18.077 1 12 5.923 1 12 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 4.107a.5.5 0 0 1 .492.41l.008.09V6.57h2.786a.5.5 0 0 1 .09.992l-.09.008h-3.27a.51.51 0 0 1-.016 0l-.017-.001h-1.35a1.32 1.32 0 0 0-1.038.382c-.24.24-.376.56-.385.921l.004.158c0 .567.68 1.15 2.561 2.26l1.005.584c2.27 1.337 3.006 1.997 3.006 3.085a2.424 2.424 0 0 1-2.265 2.465l-.195.004H12.5l.001 1.964a.5.5 0 0 1-.992.09l-.008-.09V17.43H8.713a.5.5 0 0 1-.09-.992l.09-.008h4.622a1.424 1.424 0 0 0 1.45-1.46c0-.544-.627-1.103-2.341-2.128l-1.225-.716c-2.185-1.287-2.95-1.946-3.001-2.938l-.003-.117a2.32 2.32 0 0 1 .672-1.825 2.31 2.31 0 0 1 1.611-.68l.175.006h.825l.001-1.964a.5.5 0 0 1 .5-.5"
  }))));
};
PriceGraphicIcon.displayName = "PriceGraphicIcon";
PriceGraphicIcon.iconName = "Price";
export default PriceGraphicIcon;